import { Controller } from 'stimulus'

export default class InvitationEligibilityController extends Controller {
  declare checkboxTargets: HTMLInputElement[]
  declare dobSectionTargets: HTMLElement[]
  declare dobInputTargets: HTMLInputElement[]
  declare sexSelectTargets: HTMLSelectElement[]
  declare childCardTargets: HTMLElement[]
  declare submitButtonTarget: HTMLButtonElement

  static targets = ['checkbox', 'dobSection', 'dobInput', 'sexSelect', 'childCard', 'submitButton']

  connect() {
    this.updateSubmitButton()
  }

  // Re-sync submit button when turbo stream replaces a child card
  childCardTargetConnected() {
    this.updateSubmitButton()
  }

  toggleCardClick(event: Event) {
    const target = event.target as HTMLElement

    const clickedInteractive =
      target.closest('input[type="checkbox"]') ||
      target.closest('input[type="date"]') ||
      target.closest('select') ||
      target.closest('[data-invitation-eligibility-target="dobSection"]')

    if (clickedInteractive) return

    const card = (event.currentTarget as HTMLElement)
    const childId = card.dataset.childId
    const checkbox = this.checkboxTargets.find((cb) => cb.dataset.childId === childId)
    if (!checkbox) return

    checkbox.checked = !checkbox.checked
    checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  }

  toggleChild(event: Event) {
    const checkbox = event.target as HTMLInputElement
    const childId = checkbox.dataset.childId

    const dobSection = this.dobSectionTargets.find(
      (section) => section.dataset.childId === childId
    )
    const childCard = this.childCardTargets.find(
      (card) => card.dataset.childId === childId
    )
    const dobInput = this.dobInputTargets.find(
      (input) => input.dataset.childId === childId
    )
    const sexSelect = this.sexSelectTargets.find(
      (select) => select.dataset.childId === childId
    )

    if (checkbox.checked) {
      // Show DOB section
      dobSection?.classList.remove('hidden')
      // Focus the DOB input
      dobInput?.focus()
    } else {
      // Hide DOB section
      dobSection?.classList.add('hidden')
      // Clear the DOB input and sex select
      if (dobInput) {
        dobInput.value = ''
      }
      if (sexSelect) {
        sexSelect.value = ''
      }
    }

    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const selectedCheckboxes = this.checkboxTargets.filter((cb) => cb.checked)
    const hasSelection = selectedCheckboxes.length > 0

    // Check if all selected children have DOB and sex filled
    const allFieldsFilled = selectedCheckboxes.every((checkbox) => {
      const childId = checkbox.dataset.childId
      const dobInput = this.dobInputTargets.find(
        (input) => input.dataset.childId === childId
      )
      const sexSelect = this.sexSelectTargets.find(
        (select) => select.dataset.childId === childId
      )
      return dobInput && dobInput.value.trim() !== '' && sexSelect && sexSelect.value !== ''
    })

    // Enable submit button only if at least one child selected AND all selected have DOB and sex
    this.submitButtonTarget.disabled = !(hasSelection && allFieldsFilled)
  }
}
